// extracted by mini-css-extract-plugin
export default {"selectChildrenWrapper":"ChoiceOfChildByParent_selectChildrenWrapper__hNVRC"};